import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import Header from "./Header";
import { cn } from "../../lib/utils";

export default function DashboardLayout({ nav, children, title, subtitle }) {
  const { user } = useAuth();
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Header />
      <div className="mx-auto max-w-7xl w-full px-4 sm:px-6 lg:px-8 py-10 flex-1 grid grid-cols-1 md:grid-cols-12 gap-8">
        <aside className="md:col-span-3" data-testid="dashboard-sidebar">
          <div className="mb-6">
            <div className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground mb-1">
              {user?.role === "admin" ? "Admin console" : user?.role === "owner" ? "Owner dashboard" : "Customer area"}
            </div>
            <h2 className="font-display text-2xl font-semibold tracking-tight">{title}</h2>
            {subtitle && <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>}
          </div>
          <nav className="space-y-1">
            {nav.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                data-testid={item.testId}
                className={({ isActive }) =>
                  cn(
                    "flex items-center gap-3 px-3 py-2 rounded-md text-sm transition-colors",
                    isActive
                      ? "bg-primary text-primary-foreground"
                      : "text-foreground/80 hover:bg-muted"
                  )
                }
              >
                {item.icon && <item.icon size={16} />}
                {item.label}
              </NavLink>
            ))}
          </nav>
        </aside>
        <section className="md:col-span-9 min-w-0">{children}</section>
      </div>
    </div>
  );
}
